import controller from './help.controller';
import template from './help.html';
import './help.scss';

export default {
	template,
	controller,
	controllerAs: '$ctrl',
	path: '/apidocs',
	title: 'API Documentation',
};
